(function (){
    'use strict';

    angular
        .module('services')
        .service('PlatformRentalManagementService', PlatformRentalManagementService);

    PlatformRentalManagementService.$inject = ['$http', 'API_BASE'];

    function PlatformRentalManagementService ($http, API_BASE) {
        
        var service         = this;
        service.getPlans    = getPlans;
        
        function getPlans () {
            return $http.get(API_BASE + '/platform-rental-management/list');
        }
    }
})();